{
  "pageTitle": "Akcije",
  "startScraping": "Pokreni skupljanje",
  "startScrapingDesc": "Pokreni skupljanje računa za sve adrese i pružatelje.",
  "viewLiveLogs": "Pregledaj logove uživo",
  "processPayments": "Obradi plaćanja",
  "processPaymentsDesc": "Pregledaj i obradi račune koji čekaju plaćanje.",
  "viewPendingInvoices": "Pregledaj račune koji čekaju"
}
